import styled from "styled-components";
import { DropdownList } from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const NavBarDropdownList = styled(DropdownList)`
  z-index: 510;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
